module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0, false, false), _vm._v(" "), _c('div', {
    attrs: {
      "id": "content"
    }
  }, [_c('div', {
    staticClass: "types"
  }, [_c('h2', [_vm._v("Types")]), _vm._v(" "), _c('h3', [_vm._v("Icon separator")]), _vm._v(" "), _c('h2', [_vm._v("Style")]), _vm._v(" "), _c('h3', [_vm._v("Colors")]), _vm._v(" "), _c('div', {
    staticClass: "left mt--bg--neutrals-light-gray-01 height250"
  }, [_c('img', {
    attrs: {
      "src": _vm.colors,
      "alt": ""
    }
  })]), _vm._v(" "), _vm._m(1, false, false), _vm._v(" "), _c('h3', [_vm._v("Sizing")]), _vm._v(" "), _c('div', {
    staticClass: "left mt--bg--neutrals-light-gray-01 height250"
  }, [_c('img', {
    attrs: {
      "src": _vm.sizing,
      "alt": ""
    }
  })]), _vm._v(" "), _vm._m(2, false, false)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "header-wrapper"
    }
  }, [_c('div', {
    staticClass: "header"
  }, [_c('h1', [_vm._v("Breadcrumbs")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "right mt-font--body10 height198"
  }, [_c('p', [_vm._v("Default text: #485464")]), _vm._v(" "), _c('p', [_vm._v("Hover text: #055AFE")]), _vm._v(" "), _c('p', [_vm._v("Active text: #004AD4")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "right mt-font--body10 height198"
  }, [_c('p', [_vm._v("Font size: 14px")]), _vm._v(" "), _c('p', [_vm._v("Horizontal padding: 5px")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-231393b8","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Breadcrumbs.vue
// module id = 31h+
// module chunks = 0